
import Vue from "vue";
import { Component } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import NiceButton from "@/components/UI/NiceButton.vue";
import { configStore } from "@/store/store";
import { logEvent } from "@/util/tracking";

@Component({
  components: { Icon, NiceButton }
})
export default class UpgradeToProModal extends Vue {
  toggleDialog() {
    this.dialogOpen = !this.dialogOpen;

    logEvent("Upgrade To Pro Modal Toggled", {
      open: this.dialogOpen
    });
  }

  dialogOpen = false;

  get builderMode() {
    return configStore.builderMode;
  }
}
